"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotExist = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _paulCorePackage = require("paul-core-package");
var _InfoMessage = require("./InfoMessage");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const NotExist = _ref => {
  let {
    onClose
  } = _ref;
  const {
    WARNING,
    CHART_DATA_NOT_EXIST_OR_ERROR
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsInterfaceUILocalizations);
  return /*#__PURE__*/_react.default.createElement(_InfoMessage.InfoMessage, {
    header: WARNING,
    text: CHART_DATA_NOT_EXIST_OR_ERROR,
    onClose: onClose
  });
};
exports.NotExist = NotExist;
NotExist.propTypes = {
  onClose: _propTypes.default.func
};